import login from './login'
import result from './result'

const certQuery = {
  path: 'cert_query',
  component: resolve => require(['../../../../../pages/portal/sbs/training/cert-query'], resolve),
  children: [
    login,
    result
  ]
}

export default certQuery
